/**
 * New typescript file
 */

export * from './custom.directive';
export * from './mainError.directive';
export * from './slabRange.directive';
export * from './select-search.directive';



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/common/directives/index.ts